import ProjectList from '../components/project/List'
import ProjectCreate from '../components/project/Create'
import ProjectUpdate from '../components/project/Update'

export default [
  {
    name: 'Project',
    path: '/projects/',
    component: {template: '<router-view></router-view>'},
    redirect: {name: 'ProjectList'},
    children: [
      {name: 'ProjectList', path: '', component: ProjectList},
      {name: 'ProjectCreate', path: 'create', component: ProjectCreate},
      {name: 'ProjectUpdate', path: 'edit/:id', component: ProjectUpdate}
    ]
  }
]
